const ocsHighlighRow = (ids, type='success') => {
    return {
        mode: 'checkbox',
        selected: ids,
        classes: type === 'success' ? 'alert-success' : 'alert-info',
        hideSelectColumn: true,
        bgColor: type === 'success' ? '#d4edda' : '#d1ecf1'
    }
}
export default ocsHighlighRow